(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 90492:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(66289);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ getJsonLd; }
});

// UNUSED EXPORTS: setJsonLdAccommodation, setJsonLdBreadcrumb, setSameAsByMarket

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/JsonLd/constants.js
var jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressCountry: "ES",
        addressLocality: "Barcelona",
        addressRegion: "Barcelona",
        postalCode: "08010",
        streetAddress: "Ronda Sant Pere 17, 3\xba 4\xaa"
    },
    founders: [
        {
            "@type": "Person",
            name: "Luis Osorio Sol\xe9"
        },
        {
            "@type": "Person",
            name: "Francesc L\xf3pez Castellet"
        },
        {
            "@type": "Person",
            name: "Ra\xfal Mor\xf3n Sillero"
        }, 
    ],
    foundingDate: "2015-01-29",
    foundingLocation: "Barcelona",
    legalName: "Stayforlong S.L.",
    logo: {
        "@type": "ImageObject",
        caption: "Stayforlong logo",
        url: "https://static.stayforlong.com/web/images/sfl-logo-mobile.jpg"
    },
    name: "Stayforlong",
    url: "https://www.stayforlong.com"
};
var descriptions = {
    es: "Stayforlong es un sitio web de reservas hoteleras especializado en las reservas de larga estancia. Se encuentra presente en 22 pa\xedses distintos y ofrece a sus clientes una cartera formada por m\xe1s de 720.000 establecimientos hoteleros. Stayforlong tiene su sede en la ciudad de Barcelona.",
    de: "Stayforlong ist eine Hotelreservierungswebseite spezialisiert auf Langzeitaufenthalte. Wir sind pr\xe4sent in 22 verschiedenen L\xe4ndern und bieten unseren Kunden ein Portfolio von mehr als 720.000 Hotels. Stayforlong hat den Hauptsitz in Barcelona.",
    fr: "Stayforlong est un portail de r\xe9servation d'h\xf4tels sp\xe9cialis\xe9 dans les longs s\xe9jours.Nous sommes pr\xe9sents dans 22 pays et proposons \xe0 nos utilisateurs plus de 720.000 h\xf4tels diff\xe9rents.",
    uk: "Stayforlong is a hotel reservation portal specialized in long stays. We are present in 22 countries and offer to our clients more than 720.000 different hotels. Stayforlong's headquarter is located in Barcelona, Spain.",
    pt: "Stayforlong \xe9 um portal de reservas de hot\xe9is especializado em estadias longas. Estamos presentes em 22 pa\xedses e oferecemos aos nossos usu\xe1rios mais de 720.000 hot\xe9is diferentes."
};
var sameAs = [
    "https://www.facebook.com/stayforlong",
    "https://www.instagram.com/stayforlong",
    "https://www.youtube.com/channel/UCXY0iWptc19iyKlVqkK1ZGw", 
];

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
;// CONCATENATED MODULE: ./client/components/JsonLd/mappers.js

function setAddress(param) {
    var street = param.street, locality = param.locality, region = param.region, _country = param.country, country = _country === void 0 ? DEFAULT_COUNTRY.market : _country, postalCode = param.postalCode;
    return {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: locality,
        addressRegion: region,
        postalCode: postalCode,
        addressCountry: country
    };
}
var setAmenities = function(amenities) {
    return amenities.map(function(amenity) {
        return {
            "@type": "LocationFeatureSpecification",
            value: "True",
            name: amenity.name
        };
    });
};
var mappers_mapJsonLdTypeDetail = function(accommodation, addressParam) {
    var accommodationType = accommodation.accommodationType, name = accommodation.name, url = accommodation.url, image = accommodation.photo, description = accommodation.description, latitude = accommodation.latitude, longitude = accommodation.longitude, rating = accommodation.rating, facilities = accommodation.facilities;
    return {
        "@context": "http://schema.org",
        "@type": accommodationType.toLowerCase(),
        name: name,
        url: url,
        image: image,
        description: description,
        address: setAddress(addressParam),
        geo: {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        },
        starRating: {
            "@type": "http://schema.org/Rating",
            ratingValue: rating
        },
        amenityFeature: setAmenities(facilities)
    };
};
var mappers_mapJsonLdBreadcrumb = function(param) {
    var urlHome = param.urlHome, urlList = param.urlList, urlDetail = param.urlDetail, listTitle = param.listTitle, detailTitle = param.detailTitle;
    return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: urlHome
            },
            {
                "@type": "ListItem",
                position: 2,
                name: listTitle,
                item: urlList
            },
            {
                "@type": "ListItem",
                position: 3,
                name: detailTitle,
                item: urlDetail
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./client/components/JsonLd/utils.js





function setJsonLdBreadcrumb(params) {
    return JSON.stringify(mapJsonLdBreadcrumb(params));
}
function setJsonLdAccommodation(accommodation, addressParam) {
    return JSON.stringify(mapJsonLdTypeDetail(accommodation, addressParam));
}
function setSameAsByMarket(market) {
    var linkedinMarket = market !== "es" && market !== "de" && market !== "fr" && market !== "pt" ? "https://www.linkedin.com/company/stayforlong" : "https://".concat(market, ".linkedin.com/company/stayforlong");
    var twitterMarket = market === "es" ? "https://twitter.com/stayforlong_es" : "https://twitter.com/stayforlong";
    return (0,_to_consumable_array/* default */.Z)(sameAs).concat([
        linkedinMarket,
        twitterMarket
    ]);
}
function getJsonLd(market) {
    var jsonLdMarket = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonld), {
        sameAs: setSameAsByMarket(market)
    });
    if (!descriptions[market]) {
        return JSON.stringify(jsonLdMarket);
    }
    return JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonLdMarket), {
        description: descriptions[market]
    }));
}


/***/ }),

/***/ 77555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_Head; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/constants/business.js
var business = __webpack_require__(17003);
// EXTERNAL MODULE: ./client/components/JsonLd/utils.js + 2 modules
var utils = __webpack_require__(59896);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/comps/HrefLangs/index.js + 1 modules
var HrefLangs = __webpack_require__(15363);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/pages/Home/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    title: {
        id: "page.home.title"
    },
    description: {
        id: "page.home.description"
    },
    bannerText: {
        id: "banner.text"
    },
    bannerTitle: {
        id: "banner.title"
    },
    homeTitle: {
        id: "hero.best-hotels-for-your-holidays"
    }
});
/* harmony default export */ var Home_messages = (messages);

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./client/pages/Home/Head.tsx










var Head = function(props) {
    var _pathname = props.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var title = "".concat(business/* BRAND_NAME_TITLE */.W_, ": ").concat(intl.formatMessage(Home_messages.title));
    var description = intl.formatMessage(Home_messages.description, {
        brand: business/* BRAND_NAME_TITLE */.W_
    });
    var canonicalURL = (0,page/* buildCanonicalURL */._L)({
        market: market,
        language: language,
        pathname: pathname,
        subdomain: subdomain,
        topdomain: topdomain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: (0,utils/* getJsonLd */.ZE)(market)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangs/* default */.Z, {
                pathname: pathname
            })
        ]
    });
};
/* harmony default export */ var Home_Head = (Head);


/***/ }),

/***/ 66289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_signup; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./client/components/Footer/index.tsx
var Footer = __webpack_require__(3066);
// EXTERNAL MODULE: ./client/pages/Home/Head.tsx + 1 modules
var Head = __webpack_require__(77555);
// EXTERNAL MODULE: ./client/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(56411);
// EXTERNAL MODULE: ./src/comps/Page/index.js + 4 modules
var Page = __webpack_require__(77288);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/effects/User/selectors.ts
var selectors = __webpack_require__(91907);
// EXTERNAL MODULE: ./src/effects/User/actions.ts
var actions = __webpack_require__(25595);
// EXTERNAL MODULE: ./client/helpers/Form/constants.ts
var constants = __webpack_require__(2508);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./src/hooks/useSystem.ts
var useSystem = __webpack_require__(72337);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ./client/helpers/Form/index.ts + 1 modules
var Form = __webpack_require__(5766);
// EXTERNAL MODULE: ./src/comps/LoginAndSignUpForm/index.tsx + 4 modules
var LoginAndSignUpForm = __webpack_require__(2361);
// EXTERNAL MODULE: ./src/comps/FormSignUp/styles.module.css
var styles_module = __webpack_require__(28622);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/comps/FormSignUp/index.tsx














var FormSignUp = function(param) {
    var _returnUrl = param.returnUrl, returnUrl = _returnUrl === void 0 ? "" : _returnUrl;
    var validForm = function validForm() {
        var error = {
            email: (0,Form/* validateEmail */.oH)(email, {
                required: true
            }),
            password: (0,Form/* validatePassword */.uo)(password, {
                min: constants/* MIN_LENGTH */.zH,
                required: true
            })
        };
        setErrors(error);
        return !error.email && !error.password;
    };
    var handleSubmitForm = function handleSubmitForm(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!validForm()) {
            return;
        }
        dispatch((0,actions/* createUserRequestAction */.p4)({
            data: {
                email: email,
                password: password,
                market: market,
                language: language
            },
            hostname: apiHostName
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useMarket/* useMarket */.A)(), market = ref.market, language = ref.language;
    var apiHostName = (0,useSystem/* useSystem */.u)().apiHostName;
    var isUserCreated = (0,es/* useSelector */.v9)(selectors/* getIsUserCreated */.vC);
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(""), password = ref2[0], setPassword = ref2[1];
    var ref3 = (0,react.useState)({
        email: null,
        password: null
    }), errors = ref3[0], setErrors = ref3[1];
    var redirect = function() {
        if (returnUrl) {
            var urlToRedirect = decodeURIComponent(returnUrl);
            router.replace(urlToRedirect);
        } else {
            router.push({
                pathname: routes/* routes.myDetails.pathname */._.myDetails.pathname
            });
        }
    };
    if (isUserCreated) {
        (0,actions/* resetUserAction */.hO)();
        redirect();
        return null;
    }
    var title = intl.formatMessage({
        id: "global.sign-up"
    });
    var text = "".concat(intl.formatMessage({
        id: "global.signup-body2"
    }), " ").concat(intl.formatMessage({
        id: "global.login-body"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).signUpBase,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAndSignUpForm/* LoginAndSignUpForm */.R, {
                title: title,
                text: text,
                email: email,
                setEmail: setEmail,
                password: password,
                setPassword: setPassword,
                handleSubmitForm: handleSubmitForm,
                errors: errors,
                showTerms: !isUserCreated,
                isSignUp: true
            })
        })
    });
};
/* harmony default export */ var comps_FormSignUp = (FormSignUp);

// EXTERNAL MODULE: ./src/pages/signup/styles.module.css
var signup_styles_module = __webpack_require__(79703);
var signup_styles_module_default = /*#__PURE__*/__webpack_require__.n(signup_styles_module);
;// CONCATENATED MODULE: ./src/pages/signup/index.tsx




var Content = function(param) {
    var returnUrl = param.returnUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (signup_styles_module_default()).contentBase,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_FormSignUp, {
            returnUrl: returnUrl
        })
    });
};
/* harmony default export */ var signup = (Content);

// EXTERNAL MODULE: ./client/contexts/Login/selectors.js
var Login_selectors = __webpack_require__(80528);
// EXTERNAL MODULE: ./src/utils/getRedirectLoginUrl/index.ts
var getRedirectLoginUrl = __webpack_require__(55323);
;// CONCATENATED MODULE: ./pages/signup.tsx











var pageId = "signUp";
var SignUpPage = function(param) {
    var config = param.config, referrer = param.referrer, ancillariesJSON = param.ancillariesJSON;
    var cookieReturnUrl = config.cookieReturnUrl;
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,es/* useSelector */.v9)(Login_selectors/* getLoggedIn */.v9);
    var customer = (0,es/* useSelector */.v9)(Login_selectors/* getLoginData */.MG);
    (0,react.useEffect)(function() {
        if (!isLoggedIn) return;
        if (!(customer === null || customer === void 0 ? void 0 : customer.email)) return;
        if (globalThis.window && "ReactNativeWebView" in globalThis.window) {
            var reactNativeWebView = globalThis.window.ReactNativeWebView;
            reactNativeWebView.postMessage(JSON.stringify({
                type: "SIGN_UP_SUCCESS",
                user: {
                    email: customer.email
                }
            }));
        }
        var urlToRedirect = (0,getRedirectLoginUrl/* buildRedirectLoginUrl */.u)(referrer, cookieReturnUrl);
        router.push(urlToRedirect);
    }, [
        isLoggedIn,
        customer,
        cookieReturnUrl,
        referrer,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        config: config,
        pageId: pageId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                pageId: pageId,
                hasLogin: false,
                backButton: true,
                ancillariesJSON: ancillariesJSON
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup, {
                returnUrl: cookieReturnUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
SignUpPage.pageId = pageId;
SignUpPage.pagePathView = "/signup";
var __N_SSP = true;
/* harmony default export */ var pages_signup = (SignUpPage);


/***/ }),

/***/ 15363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_HrefLangs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./lib/domain.js

function buildHref(param) {
    var country = param.country, _pathname = param.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var subDomain = country.subdomain || "www";
    var topDomain = country.topdomain || "com";
    var queryParams = !country.subdomain && !country.topdomain ? "?market=".concat(country.market, "&lang=").concat(country.language) : "";
    return "https://".concat(subDomain, ".").concat(environment/* DOMAIN */.yK, ".").concat(topDomain).concat(pathname).concat(queryParams);
}

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
;// CONCATENATED MODULE: ./src/comps/HrefLangs/index.js







var HrefLangs = function(param) {
    var pathname = param.pathname;
    var hrefDefault = buildHref({
        country: countries/* DEFAULT_COUNTRY */.U,
        pathname: pathname
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: hrefDefault
            }),
            Object.keys(countries/* COUNTRIES */.o).filter(function(key) {
                return key !== "zz" && !CountrySelector/* NEW_MARKETS.includes */.p.includes(key);
            }).map(function(key) {
                var country = countries/* COUNTRIES */.o[key];
                var href = buildHref({
                    country: country,
                    pathname: pathname
                });
                var hrefLang = countries/* COUNTRIES */.o[key].market === "no" ? "no" : country.locale;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    hrefLang: hrefLang,
                    href: href
                }, key);
            })
        ]
    });
};
HrefLangs.propTypes = {
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var comps_HrefLangs = (HrefLangs);


/***/ }),

/***/ 91907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ getCreditCard; },
/* harmony export */   "ab": function() { return /* binding */ getIsFetching; },
/* harmony export */   "hy": function() { return /* binding */ getIsPasswordChanged; },
/* harmony export */   "vC": function() { return /* binding */ getIsUserCreated; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66895);

var getCreditCard = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].creditCard;
};
var getIsFetching = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isFetching;
};
var getIsPasswordChanged = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isPasswordChanged;
};
var getIsUserCreated = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_STATE */ .F2].isUserCreated;
};


/***/ }),

/***/ 55323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ buildRedirectLoginUrl; }
/* harmony export */ });
function buildRedirectLoginUrl(referrer, cookieReturnUrl) {
    var url = new URL("/", window.location.origin);
    if (referrer) {
        url = new URL(decodeURIComponent(referrer));
    }
    if (cookieReturnUrl) {
        url = new URL(decodeURIComponent(cookieReturnUrl));
    }
    url.searchParams.append("from", "signUpSuccess");
    return url.toString();
}


/***/ }),

/***/ 28622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__o5sM_","signUpBase":"styles_signUpBase__5oRjQ"};

/***/ }),

/***/ 79703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentBase":"styles_contentBase__Oyg5C"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(90492); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);